<template>
    <CInput
        class="cc-input-editable"
        :value.sync="valueComponent"
        :readonly="!editable"
    >
        <template #append>
            <CButton v-if="editable" @click="editable = false">
                <CIcon class="icon" :content="$options.icons.cilSave" />
            </CButton>
            <CButton v-else @click="editable = true">
                <CIcon class="icon" :content="$options.icons.cilPencil" />
            </CButton>
        </template>
    </CInput>
</template>

<script>
import { cilPencil, cilSave } from "@coreui/icons";
export default {
    name: "CCInputEditable",
    icons: {
        cilSave,
        cilPencil,
    },
    data() {
        return {
            editable: false,
            valueComponent: null,
        };
    },
    props: {
        value: {
            required: true,
        },
    },
    watch: {
        value(newValue, oldValue) {
            this.valueComponent = newValue;
        },
        valueComponent(newValue, oldValue) {
            this.$emit("update:value", newValue);
        },
    },
    mounted() {
        this.valueComponent = this.value;
    },
};
</script>
<style>
.cc-input-editable {
    position: relative;
    width: 100%;
    margin: 0.7rem 0 !important;
    & input {
        background-color: white;
    }

    & .input-group-append {
        position: absolute;
        z-index: 1600;
        right: -10px;
        top: 50%;

        & button {
            background-color: white;
            border-radius: 50px !important;
        }
    }
}
</style>
